import { render, staticRenderFns } from "./LPImageTextTabs.vue?vue&type=template&id=453fd22b"
import script from "./LPImageTextTabs.vue?vue&type=script&lang=js"
export * from "./LPImageTextTabs.vue?vue&type=script&lang=js"
import style0 from "./LPImageTextTabs.vue?vue&type=style&index=0&id=453fd22b&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports